import {Modal, Typography, theme} from 'antd';
import React from 'react';
import CloseIconDialog from 'Components/CloseIconDialog';
import {useCSContext} from 'Context/ContentStackContext';
import {useDialogScrollBar} from 'Hooks';
import {SR_DASHBOARD} from 'Pages/SRDashboard/srDashboardConstants';

const {Title, Text} = Typography;

interface IProps {
  openCommentsDialog: any;
  setOpenCommentsDialog: React.Dispatch<React.SetStateAction<boolean>>;
  comments?: string;
}

const CommentsDialog: React.FC<IProps> = (props) => {
  const {openCommentsDialog, setOpenCommentsDialog, comments} = props;
  const {artifacts} = useCSContext();
  const {token} = theme.useToken();
  // Note: pre-existing quirk carried over unchanged — the hook expects
  // {isDialogVisible}, but a raw boolean has always been passed here.
  const {showScrollBar, isScrollbarVisible} = useDialogScrollBar(openCommentsDialog);

  return (
    <Modal
      // Unmount content on close, as the old MUI Dialog did, so each open starts fresh.
      destroyOnHidden
      open={openCommentsDialog}
      onCancel={() => setOpenCommentsDialog(false)}
      closable={false}
      keyboard={false}
      footer={null}
      width="70%"
      style={{top: '15%'}}>
      <CloseIconDialog callback={() => setOpenCommentsDialog(false)} image={artifacts.cross_icon} />
      <Title level={5} style={{paddingTop: 32, marginBottom: 0}}>
        {SR_DASHBOARD.comments_dialog.heading}
      </Title>
      <Text type="secondary">{SR_DASHBOARD.comments_dialog.subtitle}</Text>
      <div
        onScroll={showScrollBar}
        className={isScrollbarVisible ? 'ast-scrollbar-visible' : 'ast-scrollbar-hidden'}
        style={{
          marginTop: 16,
          marginBottom: 24,
          marginRight: 24,
          maxHeight: '50vh',
          overflowY: 'auto',
        }}>
        <Text style={{whiteSpace: 'break-spaces'}}>{comments}</Text>
      </div>
      <style>{`
        .ast-scrollbar-hidden::-webkit-scrollbar-thumb { visibility: hidden; }
        .ast-scrollbar-visible::-webkit-scrollbar-thumb { visibility: visible; background-color: ${token.colorTextQuaternary}; border-radius: 15px; }
        .ast-scrollbar-hidden::-webkit-scrollbar, .ast-scrollbar-visible::-webkit-scrollbar { width: 0.3rem; }
      `}</style>
    </Modal>
  );
};

export default CommentsDialog;
